export default "__VITE_ASSET__DVUp8YIq__"